<script setup lang="ts">

import { faFilterCircleXmark } from '@fortawesome/pro-regular-svg-icons'

import { BtnIcon } from '@shared/ui/buttons'

import { useButtonFiltersClear } from '../../model/shift-control/button-filters-clear.hook'

defineOptions({
  name: 'ButtonFiltersClear',
})

const {
  text,
  disabled,
  setClear,
} = useButtonFiltersClear()
</script>

<template>
  <BtnIcon
    :icon="faFilterCircleXmark"
    color="red"
    :tooltip-text="text"
    :disabled="disabled"
    @click="setClear"
  />
</template>
